/**
 * Map of restricted country ISO codes to their full names.
 * Users from these countries are not eligible for certain services (e.g., Socure verification).
 * Includes special cases for display purposes (e.g., "Myanmar (Burma)", "Hong Kong (China)").
 */
export const RESTRICTED_COUNTRIES_MAP: Record<string, string> = {
    TH: 'Thailand',
    TW: 'Taiwan',
    UA: 'Ukraine',
    CU: 'Cuba',
    HU: 'Hungary',
    IR: 'Iran',
    KP: 'North Korea',
    RU: 'Russia',
    BY: 'Belarus',
    SY: 'Syria',
    VE: 'Venezuela',
    MM: 'Myanmar (Burma)',
    SD: 'Sudan',
    SS: 'South Sudan',
    SO: 'Somalia',
    LY: 'Libya',
    IQ: 'Iraq',
    AF: 'Afghanistan',
    YE: 'Yemen',
    LB: 'Lebanon',
    CF: 'Central African Republic',
    CD: 'Democratic Republic of the Congo',
    ET: 'Ethiopia',
    NI: 'Nicaragua',
    ML: 'Mali',
    NE: 'Niger',
    HT: 'Haiti',
    ZW: 'Zimbabwe',
    DZ: 'Algeria',
    AO: 'Angola',
    BO: 'Bolivia',
    BG: 'Bulgaria',
    BF: 'Burkina Faso',
    CM: 'Cameroon',
    CN: 'China',
    CI: "Côte d'Ivoire",
    KE: 'Kenya',
    LA: 'Laos',
    MC: 'Monaco',
    MZ: 'Mozambique',
    NA: 'Namibia',
    AE: 'United Arab Emirates',
    IN: 'India',
};

/**
 * List of restricted country ISO codes.
 * Derived from RESTRICTED_COUNTRIES_MAP keys.
 */
export const RESTRICTED_COUNTRY_CODES = Object.keys(RESTRICTED_COUNTRIES_MAP);

/**
 * List of restricted country names for display purposes.
 * Derived from RESTRICTED_COUNTRIES_MAP values.
 */
export const RESTRICTED_COUNTRY_NAMES = Object.values(RESTRICTED_COUNTRIES_MAP);

export const REFERRALS_ALLOWLISTED_COUNTRIES_MAP: Record<string, string> = {
    US: 'United States',
    PR: 'Puerto Rico',
    AS: 'American Samoa',
    GU: 'Guam',
    MP: 'Northern Mariana Islands',
    UM: 'United States Minor Outlying Islands',
    VI: 'U.S. Virgin Islands',
};

export const REFERRALS_ALLOWLISTED_COUNTRY_CODES = Object.keys(REFERRALS_ALLOWLISTED_COUNTRIES_MAP);
export const REFERRALS_ALLOWLISTED_COUNTRY_NAMES = Object.values(REFERRALS_ALLOWLISTED_COUNTRIES_MAP);

/**
 * Whether signup collects a national ID for the given country.
 * All non-domestic countries collect one; the US and its territories collect SSN instead.
 * The backend decides per-country whether the national ID is forwarded to Socure.
 */
export const requiresNationalId = (country: string): boolean =>
    !REFERRALS_ALLOWLISTED_COUNTRY_CODES.includes(country.trim().toUpperCase() || 'US');
